import React from 'react';

const PlusIcon = ({ className }) => (
  <svg className={className} width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="24" cy="24" r="24" />
    <path d="M31 23H25V17C25 16.7348 24.8946 16.4804 24.7071 16.2929C24.5196 16.1054 24.2652 16 24 16C23.7348 16 23.4804 16.1054 23.2929 16.2929C23.1054 16.4804 23 16.7348 23 17V23H17C16.7348 23 16.4804 23.1054 16.2929 23.2929C16.1054 23.4804 16 23.7348 16 24C16 24.2652 16.1054 24.5196 16.2929 24.7071C16.4804 24.8946 16.7348 25 17 25H23V31C23 31.2652 23.1054 31.5196 23.2929 31.7071C23.4804 31.8946 23.7348 32 24 32C24.2652 32 24.5196 31.8946 24.7071 31.7071C24.8946 31.5196 25 31.2652 25 31V25H31C31.2652 25 31.5196 24.8946 31.7071 24.7071C31.8946 24.5196 32 24.2652 32 24C32 23.7348 31.8946 23.4804 31.7071 23.2929C31.5196 23.1054 31.2652 23 31 23Z" fill="white" />
  </svg>
);

export default PlusIcon;
